import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key.tsx';

export const updateFlowSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    title: z.string().min(2, t('flows.validation.titleMinLength')).max(256, t('flows.validation.titleMaxLength')),
    description: z.string().optional(),
    eventDayId: z.string().optional(),
    eventSlotId: z.string().optional(), // TODO: slots
    startTime: z.string().optional(),
    endTime: z.string().optional(),
  });
};
